@if (d) {
    <qp-table-data
        [nullValues]="nullValues"
        [data]="
            [
                { k: 'Enobeb Id',     v: d.ecid                         },
                { k: 'Local cell Id', v: d.localcellid                  },
                { k: 'Pci',           v: d.pci                          },
                { k: 'Tac',           v: d.tac                          }
            ]"
    >
    </qp-table-data>

    <qp-mobilecell-signalstrength
        [d]="d.signalstrength" [cat]="d.signalstrengthcategory"
    >
    </qp-mobilecell-signalstrength>

    <qp-mobilecell-signalquality
        [d]="d.signalquality" [cat]="d.signalqualitycategory"
    >
    </qp-mobilecell-signalquality>
        
        <!-- { k: 'Rsrp',          v: d.rsrp ? d.rsrp + ' dBm' : ''  },
                { k: 'Rsrq',          v: d.rsrq ? d.rsrq + ' dB' : ''   }, -->
        
    <qp-table-data
        [nullValues]="nullValues"
        [data]="
            [
                { k: 'Rssnr',         v: d.rssnr ? d.rssnr + ' dB' : '' },
                { k: 'Asu',           v: d.asu                          },
                { k: 'Cqi',           v: d.cqi                          },
                { k: 'Ta',            v: d.ta                           }
            ]"
    >
    </qp-table-data>
}